import { ScanBarcode, Search } from 'iconoir-react';
import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import { cn } from '@savgroup-front-common/primitive/lib/utils';

import { usePublishBottomBarHeight } from './BottomBar.hooks';
import { BottomBarAction } from './BottomBarAction/BottomBarAction';
import { BottomBarCreateAction } from './BottomBarCreateAction/BottomBarCreateAction';
import messages from './messages';

interface BottomBarProps {
  isSearchOpen: boolean;
  onToggleSearch: () => void;
}

export const BottomBar: FC<BottomBarProps> = ({
  isSearchOpen,
  onToggleSearch,
}) => {
  const ref = usePublishBottomBarHeight();

  return (
    <nav
      ref={ref}
      data-testid="appBar_bottomBar"
      className={cn(
        'fixed inset-x-0 bottom-0 z-30 grid grid-cols-3 items-end',
        'border-t sborder-base-default bg-surface-base-default px-4 pt-2 md:hidden',
        'pb-[calc(var(--spacing)*3+env(safe-area-inset-bottom))]',
      )}
    >
      <BottomBarAction
        icon={<Search className="size-6" />}
        label={safeFormattedIntlString(messages.search)}
        aria-expanded={isSearchOpen}
        onClick={onToggleSearch}
        data-testid="appBarBottomBar_search"
      />

      <BottomBarCreateAction />

      <BottomBarAction
        icon={<ScanBarcode className="size-6" />}
        label={safeFormattedIntlString(messages.scan)}
        disabled
        data-testid="appBarBottomBar_scan"
      />
    </nav>
  );
};
